export const rootStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: 1,
  borderTop: '1px solid',
  borderColor: 'divider',
  gap: 1,
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const inputStyles = {
  flex: 1,
  '& .MuiInputBase-root': {
    alignItems: 'center',
  },
};

export const hiddenFileInputStyles = {
  display: 'none',
};
